<div class="wrap">
  <ul class="list">
    <li>
      <mat-icon class="small-icon">key</mat-icon>
      <span class="text">{{property.sharedBy ? property.sharedByDisplay : property.ownerDisplay}}</span>
    </li>
    <li *ngIf="property.certified">
      <mat-icon class="small-icon" [svgIcon]="EEMO_ICON_KEY"></mat-icon>
      <span class="text">{{property.eemoId}}</span>
    </li>
    <li *ngIf="property.address && !condoMode">
      <mat-icon class="small-icon">location_on</mat-icon>
      <span class="text">{{addressDisplay}}</span>
    </li>
    <li>
      <mat-icon class="small-icon">info_outline</mat-icon>
      <span class="text">{{ keyTranslateNbAttr | translate:nbAttrParams }}</span>
    </li>
    <li>
      <mat-icon class="small-icon">photo_library</mat-icon>
      <span class="text">{{ keyTranslateNbPhoto | translate:nbPhotoParams }}</span>
    </li>
    <li>
      <mat-icon class="small-icon">library_books</mat-icon>
      <span class="text">{{ keyTranslateNbDoc | translate:nbDocParams }}</span>
    </li>
    <li *ngIf="property.parent?.uid !== highestAncestor">
      <mat-icon class="small-icon">arrow_upward</mat-icon>
      <span class="text">{{ 'propertyDetails.parentName' | translate:parentParams }}</span>
    </li>
    <li *ngIf="childrenDisplay.length > 0">
      <mat-icon class="small-icon">arrow_downward</mat-icon>
      <span>{{'propertyDetails.childs' | translate }}</span>
      <ul>
        <li *ngFor="let item of childrenDisplay">{{item}}</li>
      </ul>
    </li>
  </ul>
</div>
